import { List } from 'immutable';

export default function mergeProviders(dProviders = List(), rProviders = List(), way) {
  if (way === 'return') return rProviders;
  return dProviders;
}
